import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Row, Col } from "react-bootstrap";
import { EXPLOER, SYMBOL, trimAddress } from '../helper/constant';
import { formatPrice } from '../helper/contractHelper';
import { useAccount } from 'wagmi';
import ClipLoader from "react-spinners/ClipLoader";
import { useDirectRoi0Stats, useDirectRoi1Stats, useDirectRoi2Stats } from '../hooks/useBscAccount';

export default function Referral() {
    const { address, isConnected } = useAccount();
    const [page0, setPage0] = useState(1);
    const [page1, setPage1] = useState(1);
    const [page2, setPage2] = useState(1);
    const stats0 = useDirectRoi0Stats(page0)
    const stats1 = useDirectRoi1Stats(page1)
    const stats2 = useDirectRoi2Stats(page2)

    const override = {
        display: "block",
        marginRight: "auto",
        marginLeft: "auto"
    };

    const [referrallink, setReferrallink] = useState(
        "Please connect your wallet"
    );
    const [refcopy, setRefcopy] = useState(false);
    const [addrcopy, setAddrcopy] = useState(false);
    let base_url = `${window.location.origin}/bkrstaking?ref=`;

    useEffect(() => {
        if (address && isConnected) {
            setReferrallink(`${base_url}${address}`);
        } else {
            setReferrallink("Please connect your wallet");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, base_url]);

    return (
        <>
            <div className='ref-main text-center'>
                <article className="presentation">
                    <h2 className="page-title text-white">Refer Friends. Earn Crypto Together.</h2>
                    <p className="description">Earn up to 6% commission on every earn.</p>
                </article>
                <div className="input-group mx-3 my-3 d-flex justify-content-center">
                    <input type="text" className="ref-input" value={referrallink} readOnly={true} />
                    <span className="input-group-text" id="basic-addon2">

                        <CopyToClipboard text={`${base_url}${address}`} onCopy={() => {
                            setRefcopy(true);
                            setTimeout(() => {
                                setRefcopy(false);
                            }, 2000)
                        }}>
                            <button className="button" type="button">
                                <img src="https://s2.svgbox.net/octicons.svg?ic=copy" alt="Icon" />
                            </button>
                        </CopyToClipboard>
                        <span>{refcopy && 'copied'}</span>
                    </span>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="px-4 py-1 bd-highlight level-span">Level 1 &nbsp; :&nbsp;  3%</div>
                    <div className="px-4 py-1 bd-highlight level-span">Level 2 &nbsp; :&nbsp;  2%</div>
                    <div className="px-4 py-1 bd-highlight level-span">Level 3 &nbsp; :&nbsp;  1%</div>
                </div>
            </div>
            <div className='container dw-container'>
                <Row>

                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 1</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {stats0.totalLength ? parseInt(stats0.totalLength) : 0}</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stats0 && stats0.loading ? (
                                        <tr>
                                            <td colSpan={2}>
                                                <ClipLoader
                                                    color="#fff"
                                                    loading={true}
                                                    cssOverride={override}
                                                    size={50}
                                                // className="spinner"
                                                />
                                            </td>
                                        </tr>
                                    ) : (stats0.data && stats0.data.length > 0 ? (
                                        stats0.data.map((value, index) => (

                                            <tr>
                                                <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                <td>{formatPrice(value[2] / Math.pow(10, 18))} {SYMBOL}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-center mb-3'>
                            {
                                parseInt(page0) > 1 &&

                                <button className='theme-btn mx-3 add-btn' onClick={() => {
                                    setPage0(page0 - 1);

                                }}>
                                    Prev
                                </button>


                            }
                            {parseInt(page0) < parseInt(stats0.totalPages) &&

                                <button className='theme-btn mx-3 add-btn' onClick={() => {
                                    setPage0(page0 + 1);

                                }}>
                                    Next
                                </button>

                            }
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 2</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {stats1.totalLength ? parseInt(stats1.totalLength) : 0}</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stats1 && stats1.loading ? (
                                        <tr>
                                            <td colSpan={2}>
                                                <ClipLoader
                                                    color="#fff"
                                                    loading={true}
                                                    cssOverride={override}
                                                    size={50}
                                                // className="spinner"
                                                />
                                            </td>
                                        </tr>
                                    ) : (stats1.data && stats1.data.length > 0 ? (
                                        stats1.data.map((value, index) => (

                                            <tr>
                                                <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                <td>{formatPrice(value[2] / Math.pow(10, 18))} {SYMBOL}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-center mb-3'>
                            {
                                parseInt(page1) > 1 &&

                                <button className='theme-btn mx-3 add-btn' onClick={() => {
                                    setPage1(page1 - 1);
                                }}>
                                    Prev
                                </button>


                            }
                            {parseInt(page1) < parseInt(stats1.totalPages) &&

                                <button className='theme-btn mx-3 add-btn' onClick={() => {
                                    setPage1(page1 + 1);
                                }}>
                                    Next
                                </button>

                            }
                        </div>
                    </Col>

                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 3</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {stats2.totalLength ? parseInt(stats2.totalLength) : 0}</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stats2 && stats2.loading ? (
                                        <tr>
                                            <td colSpan={2}>
                                                <ClipLoader
                                                    color="#fff"
                                                    loading={true}
                                                    cssOverride={override}
                                                    size={50}
                                                // className="spinner"
                                                />
                                            </td>
                                        </tr>
                                    ) : (stats2.data && stats2.data.length > 0 ? (
                                        stats2.data.map((value, index) => (

                                            <tr>
                                                <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                <td>{formatPrice(value[2] / Math.pow(10, 18))} {SYMBOL}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-center mb-3'>
                            {
                                parseInt(page2) > 1 &&

                                <button className='theme-btn mx-3 add-btn' onClick={() => {
                                    setPage2(page2 - 1);
                                }}>
                                    Prev
                                </button>


                            }
                            {parseInt(page2) < parseInt(stats2.totalPages) &&

                                <button className='theme-btn mx-3 add-btn' onClick={() => {
                                    setPage2(page2 + 1);
                                }}>
                                    Next
                                </button>

                            }
                        </div>
                    </Col>

                </Row>
            </div>
            <div className='ref-main text-center dw-container'>
                <article className="presentation">
                    <h2 className="page-title text-white">BKRCoin (BKR) Contract BSC</h2>
                </article>
                <div className="input-group mx-3 my-3 d-flex justify-content-center">
                    <input type="text" className="ref-input text-center" value="0xf3e8bad99afd2287a925e54cb9488f34efc670e3" readOnly={true} />
                    <span className="input-group-text" id="basic-addon2">

                        <CopyToClipboard text={`0xf3e8bad99afd2287a925e54cb9488f34efc670e3`} onCopy={() => {
                            setAddrcopy(true);
                            setTimeout(() => {
                                setAddrcopy(false);
                            }, 2000)
                        }}>
                            <button className="button" type="button">
                                <img src="https://s2.svgbox.net/octicons.svg?ic=copy" alt="Icon" />
                            </button>
                        </CopyToClipboard>
                        <span>{addrcopy && 'copied'}</span>
                    </span>
                </div>
            </div>
        </>
    )
}
